import React from 'react'

import { Button } from '@/components/ui/button'
import useDialog from '@/hooks/useDialog'
import { useRqCertifiedAssessmentOrFail } from '@/hooks/useRqCertifiedAssessmentQuery'
import ConfirmNdaModal from '@/pages/rqCertifiedApplicationStatus/components/Content/shared/ConfirmNdaModal'
import MakePaymentClaimModal from '@/pages/rqCertifiedApplicationStatus/components/Content/shared/MakePaymentClaimModal'

const AssessmentTwoNotStartedButtons: React.FC = () => {
  const assessment = useRqCertifiedAssessmentOrFail()

  const {
    isShowingDialog: isShowingConfirmNdaDialog,
    showDialog: showConfirmNdaDialog,
    hideDialog: hideConfirmNdaDialog,
  } = useDialog()

  const {
    isShowingDialog: isShowingPaymentInstructionsDialog,
    showDialog: showPaymentInstructionsDialog,
    hideDialog: hidePaymentInstructionsDialog,
  } = useDialog()

  const shouldShowConfirmNdaModal = !assessment.ndaAgreedAt

  return (
    <>
      <Button
        variant="primary"
        className="w-full sm:w-auto"
        onClick={() => {
          if (shouldShowConfirmNdaModal) {
            showConfirmNdaDialog()
          } else {
            showPaymentInstructionsDialog()
          }
        }}
      >
        Take {assessment.assessmentTwoName}
      </Button>

      {isShowingConfirmNdaDialog && (
        <ConfirmNdaModal
          onConfirm={() => {
            hideConfirmNdaDialog()
            showPaymentInstructionsDialog()
          }}
          onHide={hideConfirmNdaDialog}
        />
      )}

      {isShowingPaymentInstructionsDialog && (
        <MakePaymentClaimModal onHide={hidePaymentInstructionsDialog} />
      )}
    </>
  )
}

export default AssessmentTwoNotStartedButtons
